import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel } from '@material-ui/core';
import { CustomCheckboxProps } from './CustomCheckboxProps';
import './Checkbox.css';

const useStyles = makeStyles({
  root: {
    width: 26,
    height: 26
  },
  icon: {
    borderRadius: 2,
    width: 26,
    height: 26,
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #2D32AA'
  },
  checkedIcon: {
    borderRadius: 2,
    width: 26,
    height: 26,
    boxSizing: 'border-box',
    border: '1.5px solid #2D32AA',
    backgroundColor: '#2D32AA',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 23,
      height: 23,
      backgroundImage:
        "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg viewBox='0 0 115 115' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3ECheck%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Assets_icone' transform='translate(-2533.000000, -6383.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cg id='chek_per-radiobutton-e-checkbox-copy' transform='translate(2533.000000, 6383.000000)'%3E%3Cg id='icon/blue/check' transform='translate(0.157895, 0.157895)'%3E%3Cg id='espanso' transform='translate(3.279352, 20.769231)'%3E%3Cpath d='M36.0728745,76.5182186 C34.6741215,76.5182186 33.2753684,75.9845587 32.2081579,74.9173482 L1.60087045,44.3100607 C-0.533441296,42.1756397 -0.533441296,38.7149393 1.60087045,36.5805182 C3.7352915,34.4462065 7.1959919,34.4462065 9.33041296,36.5805182 L36.0728745,63.3230891 L97.7952024,1.60076113 C99.9296235,-0.533550607 103.390324,-0.533550607 105.524745,1.60076113 C107.659057,3.73518219 107.659057,7.19588259 105.524745,9.33030364 L39.9377004,74.9173482 C38.8703806,75.9845587 37.4716275,76.5182186 36.0728745,76.5182186 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#2D32AA',
    },
  },
});

export function CustomCheckbox(props: CustomCheckboxProps) {
  const classes = useStyles();

  const checkLabelLength = (label: string) => {
    let windowWidth = window.innerWidth
    if (windowWidth >= 270 && windowWidth < 450) {
      if (label.length > 20) {
        return label.slice(0, 20) + "..."
      } else {
        return label
      }
    } else {
      return label
    }
  }

  return (
    <FormControlLabel
      value={props.label}
      control={<Checkbox
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        inputProps={{ 'aria-label': 'decorative checkbox' }}
        {...props}
      />}
      label={<p className={"checkbox-label"}>{checkLabelLength(props.label!)}</p>}
      labelPlacement="end"
    />
  );
}